import { render } from "./VaultAddresses.vue?vue&type=template&id=7e9d3f5b&ts=true"
import script from "./VaultAddresses.vue?vue&type=script&lang=ts"
export * from "./VaultAddresses.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__